import { SearchspringFetcher } from 'libs/searchspring/classes/searchspring-fetcher'
import { normaliseRecommendations } from 'libs/searchspring/helpers/normalisers'
import { generateSearchspringProvider } from 'libs/searchspring/fetchers/provider'

export class SearchspringRecommend extends SearchspringFetcher {
  generateHeaders() {
    return new Headers({
      Accept: 'application/json'
    })
  }

  generateURL() {
    const endpoint = `/boost/${this.params.siteID}/recommend`
    return super.generateURL(endpoint)
  }

  updateParams(options = {}) {
    const { sku, tags, limit, profile } = options

    if (sku) this.params.set('products', sku)
    if (tags) this.params.set('tags', tags)
    if (limit) this.params.set('limits', limit)
    if (profile) this.params.set('tags', profile)

    this.params.setViewedProducts()
    this.params.setCartItems()
    this.params.setShopperID()

    super.updateParams()
  }
}

export const SearchspringRecommendProvider = generateSearchspringProvider(SearchspringRecommend, async (_results) => {
  const promises = _results.map(res => normaliseRecommendations(res))
  const resolvedResults = await Promise.all(promises)
  const results = resolvedResults.flat()
  return {
    results
  }
})
